import { stagedTagKey } from './staged-tag-key.js';
export function isStagedTagKey(value) {
    return value.startsWith(stagedTagKey('')) && value.length > stagedTagKey('').length;
}
//# sourceMappingURL=is-staged-tag-key.js.map